import { render, staticRenderFns } from "./WashSummaryScreen.vue?vue&type=template&id=2d2104d5&scoped=true&"
import script from "./WashSummaryScreen.vue?vue&type=script&lang=js&"
export * from "./WashSummaryScreen.vue?vue&type=script&lang=js&"
import style0 from "./WashSummaryScreen.vue?vue&type=style&index=0&id=2d2104d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2104d5",
  null
  
)

export default component.exports